export const INSTRUMENT_TYPES = [
  "debt",
  "equity",
  "currency",
  "fund",
  "option",
  "crypto",
] as const;

export type InstrumentType = (typeof INSTRUMENT_TYPES)[number];

export const instrumentTypeLabelKey = <T extends string>(instrumentType: T) =>
  `portfolio.class.${instrumentType}` as const;

export type InstrumentTypeLabelKey = ReturnType<
  typeof instrumentTypeLabelKey<InstrumentType>
>;

export const isInstrumentType = (value: string): value is InstrumentType =>
  (INSTRUMENT_TYPES as readonly string[]).includes(value);
